import { registerPlugin } from '@capacitor/core';
import type { NavigateNativeOptions } from './launch-navigator.types';

export interface LaunchNavigatorPlugin {
    enableDebug(options: { enabled: boolean }): Promise<void>;
    setApiKey(options: { apiKey: string }): Promise<void>;
    navigate(options: NavigateNativeOptions): Promise<void>;
    isAppAvailable(options: { app: string }): Promise<{ available: boolean }>;
    availableApps(): Promise<Record<string, boolean>>;
}

export const LaunchNavigatorNative = registerPlugin<LaunchNavigatorPlugin>('LaunchNavigator');
